// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/itt-object-schema',
  type: 'object',
  required: [],
  properties: {
    comment: {
      type: 'string',
      nullable: true,
    },
    ttComment: {
      type: 'string',
      nullable: true,
    },
    isTT: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
